
import React from 'react';
import Card from 'react-bootstrap/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

type AddArticleProps = {
  btnClickHandler: (e: any) => void,
}

const AddArticleCard: React.FunctionComponent<AddArticleProps> = ({
  btnClickHandler,
}) => (
  <Card
    as="button"
    className="bg-light text-dark article-card article-card--add"
    onClick={btnClickHandler}
  >
    <Card.Text
      as="div" 
      className="article-card__body article-card--add__body"
    >
      <FontAwesomeIcon className="text-secondary" icon={faPlus} />
    </Card.Text>
  </Card>
)

export default AddArticleCard;